export default {
  AU_ABN: 'Australian Business Number (AU ABN)',
  CA_BN: 'Canadian BN',
  CH_VAT: 'Swiss VAT',
  EU_VAT: 'European VAT number',
  HK_BR: 'Hong Kong BR number',
  IN_GST: 'Indian GST number',
  MX_RFC: 'Mexican RFC number',
  NO_VAT: 'Norwegian VAT number',
  NZ_GST: 'New Zealand GST number',
  RU_INN: 'Russian INN',
  SG_UEN: 'Singaporean UEN',
  ZA_VAT: 'South African VAT number'
};
